var render = function render(){var _vm=this,_c=_vm._self._c;return _c('live-page',[_c('chat-page',{attrs:{"slot":"chat"},slot:"chat"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }